import { getErrorCode, getErrorResponse } from '../../../common/api/errors'

export const VIRTUAL_PAYMENT_FAILED = 'Не удалось создать виртуальный платёж'

/**
 * Бэкенд отдаёт машиночитаемый errorCode, а general_error — английским текстом. Сотруднику
 * показываем текст по коду; general_error и ошибки полей — фолбэк для ответов без кода.
 */
const ERROR_MESSAGE: Record<string, string> = {
  VIRTUAL_PAYMENT_PAYOUT_CLOSED: 'Выплата уже завершена или отклонена — обновите список',
  VIRTUAL_PAYMENT_NOT_IN_MATCHING: 'Выплата уже не в мэтчинге — обновите список',
  VIRTUAL_PAYMENT_ALREADY_CREATED: 'По этой выплате уже создан виртуальный платёж, он ещё не завершён',
  VIRTUAL_PAYMENT_NO_FREE_REMAINDER:
    'Нет свободного остатка: выплату держат депозиты в работе или она уже покрыта',
  VIRTUAL_PAYMENT_BALANCE_REFUSED:
    'Ledger отказал в резерве: баланса виртуального мерчанта не хватает на остаток',
  PAYOUT_NOT_FOUND: 'Выплата не найдена — обновите список',
  TICKET_STATE_INVALID: 'Тикет в неподходящем статусе — обновите список',
  INTERNAL_ERROR: 'Не удалось создать виртуальный платёж — обратитесь к администратору',
}

export interface VirtualPaymentErrorBody {
  errorCode?: string
  errors?: Record<string, string>
}

export function buildVirtualPaymentErrorText(data?: VirtualPaymentErrorBody): string {
  const byCode = data?.errorCode ? ERROR_MESSAGE[data.errorCode] : undefined
  if (byCode) return byCode

  if (data?.errors?.general_error) return data.errors.general_error

  const first = data?.errors ? Object.entries(data.errors)[0] : undefined
  return first ? `${first[0]}: ${first[1]}` : VIRTUAL_PAYMENT_FAILED
}

// Перехватчик axios отклоняет промис самим error.response, поэтому код и поля лежат в e.data.
export function virtualPaymentErrorFromException(e: unknown): string {
  return buildVirtualPaymentErrorText({
    errorCode: getErrorCode(e),
    errors: getErrorResponse<Record<string, string>>(e) ?? undefined,
  })
}
